import React, { useState, useEffect } from "react";
import IconBar from "../Partials/IconBar";
import MemoQuestion from "./MemoQuestion";
import { useHistory } from "react-router";
import { getTest } from "../../api/test";
import { Typography, CircularProgress } from "@mui/material";

export default function Memo(props) {
  const history = useHistory();

  if (
    props === undefined ||
    props.location === undefined ||
    props.location.state === undefined ||
    props.location.state.user === undefined
  )
    history.push("/login");

  const user = props.location.state.user;
  const Test = props.location.state.test;
  const [questions, setQuestions] = useState([]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const getTestData = async () => {
    setLoading(true);
    const testDataResponse = await getTest(user.token, Test.test_info.id);
    setQuestions(testDataResponse.data);
    setLoading(false);
  };

  useEffect(() => {
    getTestData();
  }, []);

  const getQuestions = () => {
    return questions.map((item, i) => {
      return (
        <div
          key={i}
          style={{
            backgroundColor: "#ffffff",
            borderRadius: "5px",
            padding: "10px",
            marginBottom: "10px",
          }}
        >
          <MemoQuestion question={item} questionNumber={i}></MemoQuestion>
        </div>
      );
    });
  };

  return (
    <div style={{ height: "100%", width: windowWidth >= 800 ? "50%" : "90%" }}>
      <div className="HeaderBox">
        <IconBar location="memo" user={user}></IconBar>
      </div>
      <div
        style={{
          backgroundColor: "rgb(33, 42, 65)",
          padding: "15px",
          borderRadius: "5px",
        }}
      >
        <Typography
          variant="h6"
          style={{
            fontWeight: "bold",
            color: "#fbcd02",
            padding: "5px",
            textAlign: "left",
            marginBottom: "5px",
            fontSize: "1.1rem",
          }}
        >
          Memorandum
        </Typography>

        <hr
          style={{
            marginBottom: "20px",
            borderColor: "#FBCD02",
            borderWidth: "1px",
            borderStyle: "solid",
            width: "100%",
          }}
        />
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              color: "white",
            }}
          >
            <CircularProgress color="inherit" />
          </div>
        ) : (
          getQuestions()
        )}
      </div>
    </div>
  );
}
